import React from "react";
import PropTypes from "prop-types";
import { Layout, Info } from "phosphor-react";
import { getZonesTotalArea } from "utils";
import Button from "components/Button";
import ReactTooltip from "react-tooltip";
import "./index.scss";

const ZoningAccordionItem = ({ item, removeItem }) => {
  const { totalArea } = getZonesTotalArea(item);

  return (
    <>
      {item && (
        <>
          <div className="item-icon">
            <Layout size={32} color="#00CA52" />
          </div>
          <div className="farm-details">
            <div className="item-name">
              {item?.data?.farm?.properties?.farm_name}
            </div>
            <div className="item-details">
              <div className="details">
                {item?.data?.details?.num_zones} zones
              </div>
              <div className="ellipse" />
              <div className="details">
                {item?.data?.details?.fields.length} Fields
              </div>
              <div className="ellipse" />
              <div className="details"> {Math.ceil(totalArea)} hectares</div>
            </div>
            <div className="item-buttons">
              <Button
                iconOnly
                color="white"
                icon="trash"
                onClick={() => removeItem(item?.data?.id)}
              />
            </div>
          </div>
          <div className="price">
            <div className="actual-price">
              AU{" "}
              {parseFloat(item?.data?.price).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </div>
            {item?.data?.original_price && (
              <div className="old-price">
                <ReactTooltip className="tooltip" effect="solid" />
                <Info size={16} weight="fill" data-tip="Subscriber discount" />
                AU{" "}
                {parseFloat(item.data.original_price).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

ZoningAccordionItem.defaultProps = {
  item: {},
  removeItem: () => {},
};

ZoningAccordionItem.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number,
      item_type: PropTypes.string,
      name: PropTypes.string,
      sub_total: PropTypes.string,
      farm: PropTypes.object,
      price: PropTypes.string,
      original_price: PropTypes.string,
      details: PropTypes.shape({
        num_zones: PropTypes.number,
        details: PropTypes.object,
        end_date: PropTypes.string,
        number_of_days: PropTypes.string,
        number_of_fields: PropTypes.string,
        number_of_years: PropTypes.string,
        total_area: PropTypes.string,
        sub_total: PropTypes.string,
        start_date: PropTypes.string,
        farm_id: PropTypes.number,
        fields: PropTypes.array,
        zones: PropTypes.object,
      }),
    }),
  }),
  removeItem: PropTypes.func,
};

export default ZoningAccordionItem;
